import { ChildrenStoreData, UpdateMyWorldRequest } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchMyWorldDetailAPI = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.get(`/child/${child.childId}/my-world`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};

export const updateMyWorldAPI = async ({ child, params }: { child: ChildrenStoreData, params: UpdateMyWorldRequest }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();

    return retryAxios.put(`/child/${child.childId}/my-world`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response;
        }
        return null;
    });
};